module.exports = __webpack_public_path__ + "static/favicon-f983fc042c18c5a30eeeb4b7654646a9.png";